import React from "react";
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faPlus,
} from "@fortawesome/free-solid-svg-icons";
import { apiRecentTransactions } from '../../services/apis/retail/apiRecentTransactions'

class RecentTransactions extends React.Component {
    state = {
        recentTransactions: []
    }

    componentDidMount() {
        apiRecentTransactions.get().then((res) => {
            this.setState({ recentTransactions: res.data });
        });
    }

    render() {
        return (
            <div className="widget widgetRightSideBar text-start widgetBlueBg">
                <div className="row">
                    <div className="col-lg-9 text-start colorLightBlue widgetTableHeader">
                        <p>Recently Added Transactions</p>
                    </div>
                    <div className="col-lg-3 text-end">
                        <Link to="/#" className="pe-3">
                            <FontAwesomeIcon icon={faPlus} />
                        </Link>
                    </div>
                    <div className="col-lg-12 mt-4 colorBlack searchTip">
                        {this.state.recentTransactions.map((search, i) => (
                            <div key={i}>
                                <p>{search.date}</p>
                                <div className="row recentSearch recentTransaction">
                                    <div className="col-12 recentBorderBottom">
                                        <p>{search.tenant} @{search.area} - {search.complex}</p>
                                        <p>{search.micromarket}, {search.city}</p>
                                    </div>
                                </div>
                            </div>
                        ))}
                        {/* <p>19 June 2021</p>
            <div className="row recentSearch recentTransaction">
              <div className="col-12 recentBorderBottom">
                <p>Skootr @ 35,901 - DLF Cyber City</p>
                <p>Sector 24, Gurgaon</p>
              </div>
            </div>
            <p>19 June 2021</p>
            <div className="row recentSearch recentTransaction">
              <div className="col-12 recentBorderBottom">
                <p>Skootr @ 35,901 - DLF Cyber City</p>
                <p>Sector 24, Gurgaon</p>
              </div>
            </div>
            <p>19 June 2021</p>
            <div className="row recentSearch recentTransaction">
              <div className="col-12 recentBorderBottom">
                <p>Skootr @ 35,901 - DLF Cyber City</p>
                <p>Sector 24, Gurgaon</p>
              </div>
            </div> */}
                    </div>
                </div>
            </div>
        );
    }
}

export default RecentTransactions;